import React from 'react'
import './project.css'
import WEB2 from '../assets/web2.jpg'
import ML from '../assets/ML-Shredded-papers.jpg'
import WEB1 from '../assets/web1.png'
import SPRING from '../assets/spring.png'
import SPRINGECOMMERCE from '../assets/SpringBoot-Ecommerce.jpg'
import YOUS from '../assets/yous-consultancy.jpg'
import DEVOPS from '../assets/devops.png';
import TEXTCLASSIFICATION from '../assets/text-classification.jpg';
const data = [
  {
    id: 1,
    image: SPRINGECOMMERCE,
    title: 'Full-Stack Spring Boot Ecommerce Application',
    github: 'https://github.com'
  },
  {
    id: 2,
    image: WEB2,
    title: 'Reactjs eCommerce application',
    github: 'https://github.com'
  },
  {
    id: 3,
    image: DEVOPS,
    title: 'A full CICD project. Deploying a Spring Boot application on AWS using GitOps. With Git/GitHub, Docker, Kubernetes, AWS, Jenkins, ArgoCD and Sonarqube',
    github: 'https://github.com'
  },
  {
    id: 4,
    image: WEB1,
    title: 'News Blog application for client',
    github: 'https://github.com'
  },
  {
    id: 5,
    image: SPRING,
    title: 'Complete Spring Boot Web application',
    github: 'https://github.com'
  },
  {
    id: 6,
    image: YOUS,
    title: 'Yous Consultancy application',
    github: 'https://github.com'
  },
  {
    id: 7,
    image: ML,
    title: 'A Machine Learning Application on the restoration of shredded pappers for information retrieval',
    github: 'https://github.com'
  },
  {
    id: 7,
    image: TEXTCLASSIFICATION,
    title: 'Email Spam and Sentiment Detection',
    github: 'https://github.com'
  }
]

const Projects = () => {
  return (
    <section id='project'>
      <h5>OUR Recent Work</h5>
      <h2>Projects</h2>

      <div className='container project__container'>
        {
          data.map(({id, image, title, github}) => {
            return (
            <article key={id} className='project__item'>
              <div className='project__item-image'>
                <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              <div className='project__item-cta'>
                {/* <a href={github} target='_blank'>
                  <BsGithub />
                </a> */}
              </div>
            </article>
            )
          })
        }
      </div>
    </section>
  )
}

export default Projects;